import { Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../components/Providers/Auth";

export const PrivateRoute = () => {
  const { authed } = useContext(AuthContext);

  return authed ? <Outlet /> : <Navigate to="/" />;
};
